import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { PasswordChangeModal } from './password-change-modal';

interface PasswordCardProps {
  className?: string;
}

/**
 * Card surface for the Account → Password section. Opens the change-password
 * modal on click. Only rendered for users with `has_password=true` on
 * /user/me — Google-only users see a "Managed by Google" card instead, lifted
 * a level up by the page that uses this component.
 */
export const PasswordCard = ({ className }: PasswordCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Card className={className}>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-gray-900 font-medium">Password</h3>
              <p className="text-gray-700 text-sm">
                Update the password used to sign in to Glitch.
              </p>
            </div>
            <Button variant="outline" onClick={() => setIsOpen(true)}>
              Change password
            </Button>
          </div>
        </CardContent>
      </Card>
      <PasswordChangeModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
